/**
 * 配置浏览器本地存储的方式，可直接存储对象数组。
 */

import { useSessionStorage, useLocalStorage } from '@vueuse/core'

type CacheType = 'sessionStorage' | 'localStorage' | 'session' | 'local'

const _sessionStorage = {}

const _localStorage = {}

const sessionCache = {
  set(key: string, value: any) {
    if (_sessionStorage[key]) {
      _sessionStorage[key].value = value
    } else {
      _sessionStorage[key] = useSessionStorage(key, value)
    }
  },
  get(key: string) {
    if (!_sessionStorage[key]) {
      // writeDefaults: false 不写入，只读取
      _sessionStorage[key] = useSessionStorage(key, null, { writeDefaults: false })
    }
    return _sessionStorage[key]?.value
  }
}

const localCache = {
  set(key: string, value: any) {
    if (_localStorage[key]) {
      _localStorage[key].value = value
    } else {
      _localStorage[key] = useLocalStorage(key, value)
    }
  },
  get(key: string) {
    if (!_localStorage[key]) {
      _localStorage[key] = useLocalStorage(key, null, { writeDefaults: false })
    }
    return _localStorage[key]?.value
  }
}

export const useCache = (type?: CacheType) => {
  return { cache: type === 'localStorage' || type === 'local' ? localCache : sessionCache }
}
